var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-title cf"},[_c('div',{staticClass:"layout-title-box fl"}),_c('div',{staticClass:"fl"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }